export var EXPAND_RESPONSE = "EXPAND_RESPONSE";
export var SHOW_PAYWALL = "SHOW_PAYWALL";
export var TOGGLE_EDIT = "TOGGLE_EDIT";

export function toggleExpandedResponse({ responseID, expanded }) {
	return { type: EXPAND_RESPONSE, responseID, expanded }
}

export function showPaywall({ paywall }) {
	return { type: SHOW_PAYWALL, paywall }
}

export function toggleEdit({ key, expanded }) {
	return { type: TOGGLE_EDIT, key, expanded }
}



// WEBPACK FOOTER //
// ./modules/lib/actions/UIActions.js